module.exports = __webpack_public_path__ + "img/logo-cobra.39fc79e6.svg";